<template>
  <div
    class="fraction"
  >
    <slot name="top">
      {{ top }}
    </slot>

    <div class="fraction-bottom">
      <slot name="bottom">
        {{ bottom }}
      </slot>
    </div>
  </div>
</template>

  <script>
export default {
  name : 'Fraction',
  props: {
    top   : { type: [String, Number], default: '' },
    bottom: { type: [String, Number], default: '' }
  }

}
  </script>

  <style scoped>
    .fraction {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      font-size: 14px;
      font-weight: 500;
    }

    .fraction-bottom {
      border-top: 1px solid #07283A;
    }

  </style>
